'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _playback = require('../../base/playback');

var _playback2 = _interopRequireDefault(_playback);

var _events = require('../../base/events');

var _events2 = _interopRequireDefault(_events);

require('./public/style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTMLImg = function (_Playback) {
  (0, _inherits3.default)(HTMLImg, _Playback);
  (0, _createClass3.default)(HTMLImg, [{
    key: 'getPlaybackType',
    value: function getPlaybackType() {
      return _playback2.default.NO_OP;
    }
  }, {
    key: 'name',
    get: function get() {
      return 'html_img';
    }
  }, {
    key: 'tagName',
    get: function get() {
      return 'img';
    }
  }, {
    key: 'attributes',
    get: function get() {
      return {
        'data-html-img': ''
      };
    }
  }, {
    key: 'events',
    get: function get() {
      return {
        'load': '_onLoad',
        'abort': '_onError',
        'error': '_onError'
      };
    }
  }]);

  function HTMLImg(params) {
    (0, _classCallCheck3.default)(this, HTMLImg);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HTMLImg.__proto__ || (0, _getPrototypeOf2.default)(HTMLImg)).call(this, params));

    _this.el.src = params.src;
    return _this;
  }

  (0, _createClass3.default)(HTMLImg, [{
    key: 'render',
    value: function render() {
      this.trigger(_events2.default.PLAYBACK_READY, this.name);
      return this;
    }
  }, {
    key: '_onLoad',
    value: function _onLoad() {
      this.trigger(_events2.default.PLAYBACK_ENDED, this.name);
    }
  }, {
    key: '_onError',
    value: function _onError(evt) {
      var m = evt.type === 'error' ? 'load error' : 'loading aborted';
      this.trigger(_events2.default.PLAYBACK_ERROR, { message: m }, this.name);
    }
  }]);
  return HTMLImg;
}(_playback2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

exports.default = HTMLImg;


HTMLImg.canPlay = function (resource) {
  return (/\.(png|jpg|jpeg|gif|bmp|tiff|pgm|pnm|webp)(|\?.*)$/i.test(resource)
  );
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/playbacks/html_img/html_img.js
// module id = 267
// module chunks = 0